module.exports = __webpack_public_path__ + "static/media/8th.6dfc26be.png";